import styled from '@emotion/styled';

export const ModalContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	margin-block: 1.5rem;

	.p2 {
		margin-inline: 5rem;
	}

	img {
		margin-block: 1.5rem;
	}
`;

export const LinkViewer = styled.span`
	font-weight: 700;
	text-decoration: underline;
	cursor: pointer;
	color: var(--blue);
`;
